"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidLogger = void 0;
const Logger_1 = require("../abstract/Logger");
class VoidLogger extends Logger_1.Logger {
    log(log) {
        // Do nothing
    }
    createChild(meta) {
        return this;
    }
    close() {
        // Do nothing
    }
}
exports.VoidLogger = VoidLogger;
//# sourceMappingURL=voidLogger.js.map